import type { PackEntry } from 'types/shared';
import type { DecodedPackCreativesGroup } from 'hooks/useLocationParams';

const DEFAULT_PACK_VISUAL_TOUCH_UPS = true;

/** Rebuilds packs (in index order) from URL-restored pack groups, restoring each pack's tag. */
export const buildPacksFromCreativesByPack = (
  creativesByPack: readonly DecodedPackCreativesGroup[],
  adType: string,
  visualTouchUps: boolean,
): PackEntry[] => {
  if (!creativesByPack.length) return [];

  const hasExplicitVisualTouchUps = creativesByPack.some(
    (group) => group.visualTouchUps !== undefined,
  );
  const fallbackVisualTouchUps = hasExplicitVisualTouchUps
    ? DEFAULT_PACK_VISUAL_TOUCH_UPS
    : visualTouchUps;

  const packCount = Math.max(...creativesByPack.map((group) => group.index)) + 1;
  const groupByIndex = new Map(creativesByPack.map((group) => [group.index, group]));

  return Array.from({ length: packCount }, (_, index) => {
    const group = groupByIndex.get(index);
    return {
      tag: group?.tag ?? '',
      adType,
      creatives: group?.creatives ?? [],
      filterCreativeByName: [],
      visual_touch_ups: group?.visualTouchUps ?? fallbackVisualTouchUps,
    };
  });
};
